<template>
  <dropdown-select :items="allComponents" :value="activeAgendaIndex" @input="selectAgendaByIndex">
    <!-- Agenda components -->
    <template #dropdown="{ item }">
      <calendar-icon class="calendar-icon"></calendar-icon>
      <span v-if="item.id === -1">{{ $t("agenda.my_schedule") }}</span>
      <span v-else>{{ item.label }}</span>
    </template>

    <!-- Placeholder text -->
    <template #placeholder>
      <span>{{ $t("agenda.select_component") }}</span>
    </template>
  </dropdown-select>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import CalendarIcon from "@/assets/icons/calendar.svg";
import DropdownSelect from "@/shared/components/DropdownSelect";

export default {
  name: "AgendaSelect",

  components: {
    CalendarIcon,
    DropdownSelect
  },

  methods: {
    ...mapActions("agendas", ["selectAgendaByIndex"]),
  },

  computed: {
    ...mapGetters("agendas", ["allComponents", "activeAgendaIndex"]),
  }
};
</script>

<style lang="scss" scoped>
.calendar-icon {
  margin: -4px 10px 0 0;
  vertical-align: middle;
  fill: var(--primary-color);
  width: 24px;
  height: 24px;

  .button:active & {
    fill: var(--primary-color-text);
  }
}

::v-deep .dropdown-trigger {

  .button {
    color: var(--primary-color) !important;
  }
}
</style>
